import { User } from '@/models/user';
import { Consts } from '@/consts';
import { StringUtils } from './stringUtils';
import { AccessTokenStatus } from '@/enums';
import { GraphApiRootError } from '@/models/graphApiRootError';
import { AccessTokenInfo } from '@/models/accessTokenInfo';

export class GraphApiUtils {
	public static async isValidAccessToken(accessTokenInfo: AccessTokenInfo): Promise<boolean> {
		try {
			const accessToken: string = accessTokenInfo.token;
			if ((StringUtils.IsEmptyOrUndefined(accessToken)) || (accessTokenInfo.isExpired())) {
				return false;
			}
			const headers: Headers = new Headers();
			const bearer: string = 'Bearer ' + accessToken;
			headers.append('Authorization', bearer);
			const options: RequestInit = {
				method: 'GET',
				headers
			};
			const response: Response = await fetch(Consts.GRAPH_API_BASE_URL + 'me?$select=id', options);
			if (response === null) {
				return false;
			}
			if ((response.status !== 200) && (response.status !== 202)) {
				return false;
			}
			const responseJson: any = await response.json();
			if ((responseJson === null) || (responseJson === Consts.EMPTY_STRING)) {
				return false;
			}
			const user: User = User.parse(responseJson);
			if (user.id === Consts.EMPTY_STRING) {
				return false;
			}
			return true;
		} catch (e) {
			return false;
		}
	}

	public static async getAccessTokenStatus(accessTokenInfo: AccessTokenInfo): Promise<AccessTokenStatus> {
		try {
			const accessToken: string = accessTokenInfo.token;
			if (StringUtils.IsEmptyOrUndefined(accessToken)) {
				return AccessTokenStatus.EmptyOrUndefined;
			}
			if (accessTokenInfo.isExpired()) {
				return AccessTokenStatus.Expired;
			}
			const headers: Headers = new Headers();
			const bearer: string = 'Bearer ' + accessToken;
			headers.append('Authorization', bearer);
			const options: RequestInit = {
				method: 'GET',
				headers
			};
			try {
				const response: Response = await fetch(Consts.GRAPH_API_BASE_URL + 'me?$select=id', options);
				if (response === null) {
					return AccessTokenStatus.FetchError;
				}
				try {
					const responseJson: any = await response.json();
					if ((responseJson === null) || (responseJson === Consts.EMPTY_STRING)) {
						return AccessTokenStatus.ParseError;
					}
					if ((response.status !== 200) && (response.status !== 202)) {
						const error: GraphApiRootError = GraphApiRootError.parse(responseJson);
						if (error.error.code === Consts.EMPTY_STRING) {
							return AccessTokenStatus.ParseError;
						}
						const errorCodeLowerCase: string = error.error.code.toLowerCase();
						if (errorCodeLowerCase === 'InvalidAuthenticationToken'.toLowerCase()) {
							return AccessTokenStatus.InvalidAuthenticationToken;
						} else if (errorCodeLowerCase === 'AuthenticationError'.toLowerCase()) {
							return AccessTokenStatus.AuthenticationError;
						}
						console.error(error.error.code + ': ' + error.error.message);
						return AccessTokenStatus.Unknown;
					}
					const user: User = User.parse(responseJson);
					if (user.id === Consts.EMPTY_STRING) {
						return AccessTokenStatus.ParseError;
					}
					return AccessTokenStatus.Valid;
				} catch (e) {
					return AccessTokenStatus.ParseError;
				}
			} catch (e) {
				return AccessTokenStatus.FetchError;
			}
		} catch (e) {
			return AccessTokenStatus.Unknown;
		}
	}
}
